module.exports = __webpack_public_path__ + "static/media/Snappy_Mail.e51ca3e5.svg";